import Translate from "../Translate";

type PageHeaderPropsType = {
    title: string | React.ReactNode,
    children?: React.ReactNode | React.ReactNode[]
};

const PageHeader = (props: PageHeaderPropsType) => {
    return (
        <header className="page-header pl-4 py-2 border-b theme-border flex">
            <div className="w-full my-auto">
                <h1>
                    {typeof props.title == 'string' ? <Translate i18nKey={props.title} /> : props.title}
                </h1>
            </div>
            <div className="flex my-auto">
                {props.children}
            </div>
        </header>
    );
};

export default PageHeader;
